import { render, staticRenderFns } from "./violationList.vue?vue&type=template&id=7638d12e&scoped=true"
import script from "./violationList.vue?vue&type=script&lang=js"
export * from "./violationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7638d12e",
  null
  
)

export default component.exports